import { render, staticRenderFns } from "./courseDes.vue?vue&type=template&id=03208b8f&scoped=true"
import script from "./courseDes.vue?vue&type=script&lang=js"
export * from "./courseDes.vue?vue&type=script&lang=js"
import style0 from "./courseDes.vue?vue&type=style&index=0&id=03208b8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03208b8f",
  null
  
)

export default component.exports